import { fullySupported } from './fullySupported.ts';
import type { OneOnOneColleagueItem } from '@/lib/colleagues.ts';

export type TeamFilter =
  | 'all'
  | 'memory'
  | 'no_memory'
  | 'nothing_planned'
  | 'action'
  | 'planned'
  | 'hidden';

const ACTION_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * A 1:1 with them within the week that Wundo will not be ready for: no
 * automatic preparation, or no notetaker to write it up.
 */
export function needsAction(colleague: OneOnOneColleagueItem, now = new Date()): boolean {
  if (colleague.next_one_on_one_at === null) return false;
  const soon =
    new Date(colleague.next_one_on_one_at).getTime() - now.getTime() <= ACTION_WINDOW_MS;
  return soon && !fullySupported(colleague);
}

/** Whether a colleague on the page belongs in this selection. Hidden ones come from their own list. */
export function inTeamFilter(
  colleague: OneOnOneColleagueItem,
  filter: TeamFilter,
  now = new Date(),
): boolean {
  switch (filter) {
    case 'memory':
      return colleague.memory;
    case 'no_memory':
      return !colleague.memory;
    case 'nothing_planned':
      return colleague.next_one_on_one_at === null;
    case 'action':
      return needsAction(colleague, now);
    case 'planned':
      return colleague.next_one_on_one_at !== null;
    case 'all':
    case 'hidden':
      return true;
  }
}
